import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import forOwn from 'lodash/forOwn'
import has from 'lodash/has'
import kebabCase from 'lodash/kebabCase'
import Config from './config.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    exhibitdata: null,
    exhibits: null,
    location: null,
    inGarden: false,
    items: {}
  },
  mutations: {
    exhibitdata(state, exhibits) {
      state.exhibitdata = exhibits
    },
    exhibits(state, exhibits) {
      state.exhibits = exhibits
    },
    location(state, location) {
      state.location = location
    },
    inGarden(state, inGarden) {
      state.inGarden = inGarden
    },
    items(state, {items, key}) {
      const nitems = { ...state.items }
      nitems[key] = items
      // Vue.set(state.items, key, items)
      state.items = nitems
    },
  },
  actions: {
    /**
     * Fetch exhibit data from the API if it isn't already present
     * https://vuejsdevelopers.com/2017/08/28/vue-js-ajax-recipes/ - inspiration from here
     */
    async refreshExhibitData(context) {
      if (context.exhibitdata) {
        return
      }
      try {
        const result = await axios.get(Config.exhibit_data_url)
        context.commit('exhibitdata', result.data)
      } catch (e) {
        console.log('Exhibitdata error', e)
      }
    },
    /**
     * Fetch exhibit locations from the API if not already present.
     * Also calculates friendly URL slugs
     */
    async refreshExhibits(context) {
      if (context.exhibits) {
        return
      }
      try {
        const result = await axios.get(Config.exhibit_locations_url)
        forOwn(result.data, (value) => {
          value.friendly = kebabCase(value.name)
        })
        context.commit('exhibits', result.data)
      } catch (e) {
        console.log('Exhibits error', e)
      }
    },

    /**
     * Fetch items with the given key and throw them into the state.
     * Makes no attempt to reconcile duplicate keys - simply overwrite.
     */
    async refreshItems(context, key) {
      if (has(context.items, key) && context.items.key) {
        return
      }
      try {
        const result = await axios.get(Config.items_url + encodeURI(key))
        context.commit('items', {items: result.data, key: key })
      } catch (e) {
        console.log('Items error', e)
      }
    }
  },
  getters: {
    /**
     * Fetch all exhibits AND their data from the store
     */
    allExhibits(state) {
      const exhibits = state.exhibits
      forOwn(exhibits, (value, key) => {
        if (has(state.exhibitdata, key)) {
          value.data = state.exhibitdata[key]
          value.thumbnail = value.data.thumbnail
        }
      })
      return exhibits
    },
    /**
     * Fetch all exhibits AND their data from the store, keyed by the friendly URL slug
     */
    bySlug(state, getters) {
      const exhibits = {}
      forOwn(getters.allExhibits, (value) => {
        exhibits[value.friendly] = value
      })
      return exhibits
    },
    exhibitsGrouped(state, getters) {
      const exhibits = {}
      if (getters.loaded) {
        forOwn(getters.allExhibits, (value) => {
          value.data.groups.forEach(group => {
            if (!has(exhibits, group)) {
              exhibits[group] = {}
            }
            exhibits[group][value.friendly] = value
          })
        })
      }
      return exhibits
    },
    exhibitsGroupedArray(state, getters) {
      const exhibits = {}
      if (getters.loaded) {
        forOwn(getters.allExhibits, (value) => {
          value.data.groups.forEach(group => {
            if (!has(exhibits, group)) {
              exhibits[group] = []
            }
            exhibits[group].push(value)
          })
        })
      }
      return exhibits
    },
    /**
     * Check whether or not exhibit data has been loaded at all
     */
    loaded(state) {
      return state.exhibitdata !== null
    },
    // mapmarkers(state, getters) {
    //   const markers = []
    //   this.getters.allExhibits.forOwn((item) {

    //   })
    // }
    itemsDict(state) {
      const itemsDict = {}
      forOwn(state.items, (value, key) => {
        const dict = {}
        value.forEach((item) => {
          dict[item.friendly] = item
        })
        itemsDict[key] = dict
      })
      return itemsDict
    }
  }
})
